import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { ThreeColumnTemplateComponent } from '@templates/three-column-template/three-column-template.component';
import { IRelated_Response, IRelatedItems_Item } from '@shared/constants/models.const';
import { RelatedItemComponent } from '@shared/components/related-item/related-item.component';
import { ActivatedRoute } from '@angular/router';
import { ContentService } from '../../services/content.service';
import { BehaviorSubject, take } from 'rxjs';
import { CategoriesComponent } from '@shared/components/categories/categories.component';
import { TagItemComponent } from '@shared/components/tag-item/tag-item.component';
import { AsyncPipe } from '@angular/common';
import { PaginatorComponent } from '@shared/components/paginator/paginator.component';
import { E_CONTENT_TYPE, E_FOLDER_TYPES, E_QPROPS } from '@shared/constants/enums.const';
import { TranslateModule } from '@ngx-translate/core';
import { HelperService } from '../../services/helper.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ResponsivityService } from '../../services/responsivity.service';

@UntilDestroy()
@Component({
  selector: 'app-related-page',
  imports: [
    ThreeColumnTemplateComponent,
    RelatedItemComponent,
    CategoriesComponent,
    TagItemComponent,
    PaginatorComponent,
    TranslateModule,
    AsyncPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './related-page.component.html',
  styleUrl: './related-page.component.scss',
})
export class RelatedPageComponent implements OnInit {
  pageData: IRelated_Response | undefined;
  relatedId = '';
  isMobileVersion!: BehaviorSubject<boolean>;
  isCategoriesShown = true;

  queryParams: any;
  dataLoaded = false;
  HELPER: HelperService = inject(HelperService);

  constructor(
    private CONTENT: ContentService,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private resposivityService: ResponsivityService,
  ) {}

  get relatedItems(): IRelatedItems_Item[] {
    return this.pageData?.relatedItems?.items || [];
  }

  ngOnInit() {
    this.getUrlParams();
    this.isMobileVersion = this.resposivityService.isMobileOpen;
  }

  getUrlParams(): void {
    this.route.queryParams
      .pipe(untilDestroyed(this))
      .subscribe(params => {
        if (params) {
          // Params are string, so we need to parse param as boolean
          this.isCategoriesShown = (/true/).test(params['show-categories'])
            && params[E_QPROPS.contentType] !== E_CONTENT_TYPE.Publications;
          this.queryParams = {
            ...params,
            [E_QPROPS.contentType]: this.HELPER.getContentType(params[E_QPROPS.contentType]),
          };

          if (window.location.href.includes('/tag-related/')) {
            this.isCategoriesShown = true;
          }


        }
        this.dataLoaded = false;
        this.getData();
      });
  }


  getData(): void {
    this.pageData = undefined;
    const relatedId = this.relatedId || this.route.snapshot.paramMap.get('ID');

    let getData$ = this.CONTENT.getRelated(relatedId, this.queryParams);
    if (this.HELPER.getUrlArray().includes(E_FOLDER_TYPES.TagRelated)) {
      getData$ = this.CONTENT.getTagRelated(relatedId, this.queryParams);
    }

    getData$.pipe(take(1))
      .subscribe(data => {
        this.pageData = data as IRelated_Response;
        this.HELPER.$pageData.next(data);
        this.cd.detectChanges();
      });
  }

  goBack() {
    this.HELPER.goLastUrl();
  }


}
